import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacilityAddFailed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 73H121",
			stroke: "url(#paint0_linear_8280_29440)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 91H121",
			stroke: "url(#paint1_linear_8280_29440)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105 37C105 39.7614 102.761 42 100 42C97.2386 42 95 39.7614 95 37C95 34.2386 97.2386 32 100 32C102.761 32 105 34.2386 105 37Z",
			fill: "url(#paint2_linear_8280_29440)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60 109V32C60 30.8954 60.8954 30 62 30H102.444C103.549 30 104.444 30.8954 104.444 32V56.6667H138C139.105 56.6667 140 57.5621 140 58.6667V109C140 109.552 139.552 110 139 110H104.444H61C60.4477 110 60 109.552 60 109Z",
			fill: "url(#paint3_linear_8280_29440)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.334 78.8889H91.1118M73.334 47.7778H91.1118M73.334 96.6667H91.1118M117.778 74.4445H126.667M117.778 87.7778H126.667",
			stroke: "url(#paint4_linear_8280_29440)",
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.333 55.9998C156.333 63.3636 150.363 69.3332 142.999 69.3332C135.636 69.3332 129.666 63.3636 129.666 55.9998C129.666 48.636 135.636 42.6665 142.999 42.6665C150.363 42.6665 156.333 48.636 156.333 55.9998Z",
			fill: "#DB5543",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M143 48.3335C143.552 48.3335 144 48.7812 144 49.3335V57.3335C144 57.8858 143.552 58.3335 143 58.3335C142.448 58.3335 142 57.8858 142 57.3335V49.3335C142 48.7812 142.448 48.3335 143 48.3335ZM143 60.3335C143.552 60.3335 144 60.7812 144 61.3335V62.6668C144 63.2191 143.552 63.6668 143 63.6668C142.448 63.6668 142 63.2191 142 62.6668V61.3335C142 60.7812 142.448 60.3335 143 60.3335Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_8280_29440",
				x1: 97,
				y1: 73.5,
				x2: 121,
				y2: 73.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_8280_29440",
				x1: 97,
				y1: 91.5,
				x2: 121,
				y2: 91.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_8280_29440",
				x1: 100,
				y1: 32,
				x2: 100,
				y2: 42,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_8280_29440",
				x1: 100,
				y1: 30,
				x2: 100,
				y2: 110,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_8280_29440",
				x1: 100.001,
				y1: 47.7778,
				x2: 100.001,
				y2: 96.6667,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgFacilityAddFailed);
export { ForwardRef as ReactComponent };
